export class TransferLeadsInput {
  leadIds: string[];
  userId: string;
  comments?: string;

  constructor(leadIds: any, userId: any) {
    this.leadIds = leadIds;
    this.userId = userId;
  }
}
